import {axios} from '@/api/axios';
import {AxiosResponse} from 'axios';
import {VIDEO_CHANNEL_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {Channel} from '@/types/channel';
import {VideoChannel} from '@/types/video-channel';

export const VideoChannelApi = {
  getList: () => axios.get<VideoChannel[]>(VIDEO_CHANNEL_URLS.GET_LIST),
  getOne: (channelId: string) => axios.get<VideoChannel>(formatString(VIDEO_CHANNEL_URLS.GET_ONE, channelId)),

  save: (data: any) => axios.post<Required<VideoChannel>>(VIDEO_CHANNEL_URLS.SAVE, data),
  edit: (channelId: string, data: VideoChannel) => axios.put<AxiosResponse<Channel>>(formatString(VIDEO_CHANNEL_URLS.EDIT, channelId), data)
};
